import { ToastContentProps } from 'react-toastify'
import { Icon } from '../Icon'
import { ProgressWheel } from '../ProgressWheel'
import * as styles from './styles'
import { useIconProps } from './useIconProps'

type TypeIconProps = {
  errorCount?: string
  progress?: ToastContentProps['toastProps']['progress']
  showProgressWheel?: boolean
  type: ToastContentProps['toastProps']['type']
}

export const TypeIcon = ({
  errorCount,
  progress,
  showProgressWheel,
  type,
}: TypeIconProps) => {
  const iconProps = useIconProps(type)

  if (errorCount !== undefined) {
    return <div css={styles.errorCount}>{errorCount}</div>
  }

  if (showProgressWheel) {
    const progressNumber =
      typeof progress === 'string' ? Number(progress) : progress
    return <ProgressWheel size={20} strokeWidth={4} progress={progressNumber} />
  }

  if (iconProps !== null) {
    return (
      <Icon
        color={iconProps.color}
        glyph={iconProps.glyph}
        height={iconProps.size}
        css={iconProps.styleOverrides}
        width={iconProps.size}
        ariaHidden
      />
    )
  }

  return null
}
TypeIcon.displayName = 'Lapidary: TypeIcon ← Toast'
